module.exports = __webpack_public_path__ + "static/media/icon3-orange.be104ad0.svg";